'use client';
import { ReactNode } from 'react';

import { AccordionProvider } from '@/components/molecules/accordion/AccordionProvider';

interface AccordionProps {
  children: ReactNode;
}

export function Accordion({ children }: AccordionProps) {
  return <AccordionProvider>{children}</AccordionProvider>;
}
